import { createSlice } from "@reduxjs/toolkit";
import {
	addSessionHighlight,
	addSessionResult,
	appendSession,
	clearEvent,
	eventBooked,
	eventCheckedIn,
	sessionArchived,
	sessionProcessingDone,
	sessionSharelinkReady,
	sessionStreamReady,
	setEvent,
	updateEvent,
	updateSessionHighlight,
} from "./events-action";

import {
	addSessionHighlightHandler,
	addSessionResultHandler,
	appendSessionHandler,
	clearEventHandler,
	eventBookedHandler,
	eventCheckedInHandler,
	sessionArchivedHandler,
	sessionProcessingDoneHandler,
	sessionSharelinkReadyHandler,
	sessionStreamReadyHandler,
	setEventHandler,
	updateEventHandler,
	updateSessionHighlightHandler,
} from "./events-handlers";

import {
	connectSseThunk,
	fetchAgentsThunk,
	fetchEventThunk,
	getAppendCodeThunk,
	getCheckInCodeThunk,
} from "./events-thunks";
import type { State } from "./events-types";

const initialState: State = {
	events: {},
	sse_connected: false,
	agents: [],
	agentsLoading: false,
	agentsError: null,
	appendTokens: {},
	checkInTokens: {},
};

export const EventsSlice = createSlice({
	name: "events",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(setEvent, setEventHandler)
			.addCase(updateEvent, updateEventHandler)
			.addCase(clearEvent, clearEventHandler)
			.addCase(addSessionResult, addSessionResultHandler)
			.addCase(addSessionHighlight, addSessionHighlightHandler)
			.addCase(appendSession, appendSessionHandler)
			.addCase(updateSessionHighlight, updateSessionHighlightHandler)
			.addCase(eventBooked, eventBookedHandler)
			.addCase(eventCheckedIn, eventCheckedInHandler)
			.addCase(sessionStreamReady, sessionStreamReadyHandler)
			.addCase(sessionSharelinkReady, sessionSharelinkReadyHandler)
			.addCase(sessionProcessingDone, sessionProcessingDoneHandler)
			.addCase(sessionArchived, sessionArchivedHandler)
			.addCase(
				fetchEventThunk.fulfilled,
				(state, { payload: { eventData, eventId } }) => {
					state.events[eventId] = eventData;
				},
			)
			.addCase(connectSseThunk.pending, (state, _payload) => {
				state.sse_connected = true;
			})
			.addCase(connectSseThunk.fulfilled, (state, _payload) => {
				state.sse_connected = false;
			})
			.addCase(connectSseThunk.rejected, (state, _payload) => {
				state.sse_connected = false;
			})
			.addCase(fetchAgentsThunk.pending, (state) => {
				state.agentsLoading = true;
				state.agentsError = null;
			})
			.addCase(fetchAgentsThunk.fulfilled, (state, action) => {
				state.agentsLoading = false;
				state.agents = action.payload;
			})
			.addCase(fetchAgentsThunk.rejected, (state, action) => {
				state.agentsLoading = false;
				state.agentsError = action.payload as string;
			})
			.addCase(getAppendCodeThunk.fulfilled, (state, action) => {
				state.appendTokens[action.payload.eventId] = action.payload.token;
			})
			.addCase(getCheckInCodeThunk.fulfilled, (state, action) => {
				state.checkInTokens[action.payload.eventId] = action.payload.token;
			});
	},
});
